import { Component, Input, OnInit } from '@angular/core';
import { CookieService } from 'src/app/services/cookie.service';

@Component({
  selector: 'app-popup',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss'],
  providers: [CookieService]
})
export class PopUpComponent implements OnInit {
  @Input() imageUrl: string = '';
  @Input() redirectUrl: string = '';
  @Input() popupId!: string;
  isPopupVisible: boolean = true;

  constructor(private cookieService: CookieService) {}

  ngOnInit() {
    const popupClosed = this.cookieService.getCookie('popupClosed');
    if (popupClosed) {
      this.isPopupVisible = false;
    }
  }

  closePopup() {
    this.isPopupVisible = false;
    this.cookieService.setCookieWithExpiryInDays('popupClosed', 'true', 15, window.location.hostname);
  }  
}
